import { fn } from '@storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { PeriodSelectorProps } from './PeriodSelector';

import { PeriodSelector } from './PeriodSelector';

const codeString =
  '<PeriodSelector maxPeriods={} defaultValues={} label={} labelPosition={} required={} onChange={} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Organisms/PeriodSelector',
  component: PeriodSelector,
  parameters: {
    inspectComponent: PeriodSelector,
    codeString: codeString,
  },
} as Meta<PeriodSelectorProps>;

const Template: StoryFn<PeriodSelectorProps> = (args) => <PeriodSelector {...args} />;

export const PeriodSelectorExample = Template.bind({});

PeriodSelectorExample.args = {
  maxPeriods: 7,
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  defaultValues: [1, 5, 6],
  label: 'Periode',
  labelPosition: 'top',
  required: true,
  onChange: fn(),
};
